/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import { decodeJWT, type AuthTokenDecoder, type Email } from "src/utils";

export class OktaAuthTokenDecoder implements AuthTokenDecoder {
  extractEmail(token: string): Email {
    return decodeJWT<OktaDecodedAccessToken>(token)?.payload.sub ?? null;
  }
}

type OktaDecodedAccessToken = {
  sub: string;
};

export const oktaAuthTokenDecoder = new OktaAuthTokenDecoder();
